/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConstants } from '../app.constants';
import { ClientError } from '../Models/errordata';
import { LoadingService } from '../services/loading.service';
import { ApplicationType, UtilityService } from '../services/Utility.Service';

@Component({
  selector: 'error',
  templateUrl: './error.component.html',
})
export class ErrorComponent implements OnInit, OnDestroy {

  contactUsLink: string = "";
  errorId: string | null = null;
  errorMessage: string = "";
  errorCode: string = "";
  requestUrl: string = "";
  displayMessage: string = "";
  errorPath: string = "";
  @Input() inputErrorMessage: string = "";

  private subscriptions: Subscription = new Subscription();

  public constructor(
    private utilService: UtilityService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: LoadingService   ) {
  }

  ngOnInit() {
    if (!window.frameElement) {
      let errorService = this.utilService.errorService;
      if (this.route.snapshot.queryParamMap.get(errorService.UseClientErrorList)) {
        this.utilService.titleService.setTitle("Client Error");
        errorService.AboutToRoute = false;
        this.errorCode = "";
        this.errorId = null;
      this.requestUrl = null;
      this.errorMessage = this.FormatClientErrors();
      this.utilService.errorService.MapClientErrors();
      let clientError: ClientError[] = [];
        this.subscriptions.add(this.utilService.errorService.clientErrorObj
        .subscribe(errorList => {
          if (errorList !== null) {
            for (let i = 0; i < errorList.length; i++) {
              clientError.push({
                message: errorList[i].message,
                Timestamp: errorList[i].Timestamp,
                mapStack: errorList[i].mapStack,
                url: errorList[i].url
              });
            }
            this.subscriptions.add(this.utilService.errorService.LogError(clientError)
              .subscribe(x => {
                this.errorId = x;
              }));
          }
        }));
      }
      else {
        this.utilService.titleService.setTitle("Error");
        this.errorCode = this.route.snapshot.queryParamMap.get('errorCode');
        this.errorMessage = this.route.snapshot.queryParamMap.get('errorMessage');
        this.errorId = this.route.snapshot.queryParamMap.get('errorId');
        this.requestUrl = this.route.snapshot.queryParamMap.get('requestUrl');
      }
    }
    this.loadingService.ShowLoading.next(false);
  }

  public GetShortErrorMessage(error: Error): String {
    let theshortErrorMessage = new String("hi");
    if (error.message.indexOf('Error:') > -1) {
      let thesplitErrorMessage = error.message.split(':');
      theshortErrorMessage = (thesplitErrorMessage[2] + thesplitErrorMessage[3]).replace('Error', '.');
    }
    else {
      theshortErrorMessage = error.toString();
    }
    return theshortErrorMessage;
  }

  FormatClientErrors(): string {
    let errorService = this.utilService.errorService;
    let errMessage = "Errors(" + errorService.ClientErrorList.length + "): ";
    for (var anError of errorService.ClientErrorList) {
      errMessage = errMessage + this.GetShortErrorMessage(anError) + "****";
     }
    return errMessage;
  }

  ReturnToProjectList() {    
    this.router.navigate(['/page'], {
      queryParams: { aspxpath: `/${AppConstants.WEBAPP_NAME}/Views/Services/Portfolio/Portfolio_Default.aspx` }
    });      
  }

  GoBack() {
    this.router.navigate([this.utilService.errorService.getPreviousUrl()]);
  }

  EmailAdmin() {
    let theUrl = this.requestUrl;
    if (!theUrl) {
      theUrl = "/qsmcollab" + this.utilService.errorService.getPreviousUrl();
     }
    theUrl = encodeURI(theUrl);
    let contactUsLinkPage = "Views/MyAccount/ContactUs.aspx?ErrorFileId=" + this.errorId + "&aspxerrorpath=" + theUrl +
      "&errorText=" + encodeURI(this.errorMessage) + "&WebErrorCode=" + encodeURI(this.errorCode);
    this.utilService.NavigateToAspx(`/${AppConstants.WEBAPP_NAME}/` + contactUsLinkPage);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
